export default "__VITE_ASSET__DzY_bAUk__"